<template>
  <li>
    <a
      class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out rounded-md"
    >
      <div class="px-1 py-2">
        <div class="flex items-center justify-between">
          <div class="text-sm leading-5 font-medium text-indigo-600 truncate">
            {{ template.name }}
          </div>
          <div class="flex">
            <button
              class="Polaris-Button Polaris-Button--sizeSlim Polaris-Button--outline"
              type="button"
              @click="$emit('edit', template)"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Edit</span>
              </span>
            </button>
            <div class="ml-2" style="color:#bf0711">
              <button
                class="Polaris-Button Polaris-Button--sizeSlim Polaris-Button--outline Polaris-Button--monochrome"
                type="button"
                @click="$emit('delete', template)"
              >
                <span class="Polaris-Button__Content">
                  <span class="Polaris-Button__Text">Delete </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  props: {
    template: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
